import React, { Component } from 'react';
import { Layout,  Tabs } from 'antd';
import { FormattedMessage, FormattedHTMLMessage, defineMessages ,   injectIntl } from 'react-intl';
import GuideNav from '../../components/navigation/GuideNav';
import APIDemo from './APIDemo';
import Headline from '../../components/Headline';



const { Content } = Layout;
const TabPane = Tabs.TabPane;

const messages=defineMessages({
  service:{
    id:'Guide.channel.tabs.service',
    defaultMessage:'Service'
  },
  test:{
    id:'Guide.channel.tabs.test',
    defaultMessage:'Test'
  },
});
class Channel extends Component{

  render(){
    const {formatMessage}=this.props.intl;
    return(
      <Layout style={{background: '#fff' }}>
        <GuideNav selectedKey={"channel"}/>
        <Content style={{margin:20}}>
          <Headline id="Guide.channel.headline" defaultMessage="Channel"/>
          <div className="guide-wrapper">
          <Tabs
            defaultActiveKey="1"
            onChange={(key)=>{console.log(key);}}
            tabBarStyle={{width:'193px'}}
            className="channel-tabs"
            size="large">
            <TabPane tab={formatMessage(messages.service)} key="1" style={{width:'663px'}}>
              {/* mojitok app */}
              <div className="channel-service-container">
                <div className="channel-service-appimg">
                  <img src={require('../../img/guide/channel/mojitok_app_icon.svg').default} alt=""/>
                </div>

                <div className="channel-service-explain-container">
                  <p className="channel-service-subtitle">
                    <FormattedMessage id={'Guide.channel.service.mojitok.title'}  defaultMessage={'Meet Mojitok on the App Store.'}/>
                  </p>
                  <p className="channel-service-explain">
                    <FormattedHTMLMessage id={'Guide.channel.service.mojitok.explain'}
                      defaultMessage={'1) Open the mojitok app.<br/>2) Type in the discover menu to see recommended stickers.<br/>3) Use the recommended sticker on Whatsapp/Telegram/iMessage.'}/>
                  </p>
                  <div style={{marginBottom:'24px'}}>
                    <a href="https://itunes.apple.com/us/app/mojitok-stickers/id1401180608?l=ko&ls=1&mt=8" target="_blank" rel="noopener noreferrer">
                      <img src={require('../../img/icon_app_store.svg').default} alt="" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.mojitok.app" target="_blank" rel="noopener noreferrer" >
                      <img src={require('../../img/icon_google_play.png').default} alt="" style={{height: 50, marginLeft: 8}} />
                    </a>
                  </div>
                  <div className="channel-service-image">
                    <img src={require('../../img/guide/channel/channel_mojitok_img_02.png').default} alt=""/>
                  </div>
                  <div className="channel-service-image">
                    <img src={require('../../img/guide/channel/channel_mojitok_img_01.png').default} alt=""/>
                  </div>
                </div>
              </div>
              {/* mojitok galaxy keyboard*/}
              <div className="channel-service-container">
                <div className="channel-service-appimg">
                  <img src={require('../../img/guide/channel/channel_mojitok_galaxy_icon.svg').default} alt=""/>
                </div>

                <div className="channel-service-explain-container">
                  <p className="channel-service-subtitle">
                    <FormattedMessage id={'Guide.channel.service.mojitok.galaxy.title'}  defaultMessage={'Meet mojitok on the Galaxy Keyboard.'}/>
                  </p>
                  <p className="channel-service-explain" style={{marginBottom:10}}>
                    <FormattedHTMLMessage id={'Guide.channel.service.mojitok.galaxy.explain'}
                      defaultMessage={'1) Open the Galaxy keyboard on your Galaxy  S10, Note 10/10+.<br/>2) Click on the sticker icon.<br/>3) Click on the mojitok icon.<br/>4) Press \'Download mojitok\' to use mojitok on the Galaxy keyboard.'}/>
                  </p>
                  <p style={{ fontSize: 14, color:'#979797', marginBottom:34}}>
                    <FormattedMessage id={'Guide.channel.service.mojitok.galaxy.caution'}  defaultMessage={'* It will soon be updated for all Galaxy devices.'}/>
                  </p>
                  <img src={require('../../img/guide/channel/galaxy_icon@2x.png').default} style={{marginBottom:'34px',width:'135px'}} alt="" /> <br/>
                  <div className="channel-service-image">
                    <img src={require('../../img/guide/channel/channel_galaxy_img_01@2x.png').default} alt="" width={230}/>
                  </div>
                  <div className="channel-service-image">
                    <img src={require('../../img/guide/channel/channel_galaxy_img_02@2x.png').default} alt="" width={230}/>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tab={formatMessage(messages.test)} key="2" style={{marginBottom:100}}>
              <p className="channel-test-explain">
                <FormattedHTMLMessage
                  id={'Guide.channel.test.explain'}
                  defaultMessage={'<b>This feature is designed to demonstrate the function of mojitok<br/> before submitting your content.🕵🏻</b><br/><br/>Currently, we only offer automated suggestions based on the sentences you type. <br/>We would notify you that your content may not be appeared, <br/>as only some of the results will be shown.😥<br/>All the features such as \'search by emotion and pack\' will be provided so<br/> that you can experience in the near future.🔜✨'}
                />
              </p>
              <div className="channel-test-demo-box">
                <APIDemo/>
              </div>
            </TabPane>
          </Tabs>
          </div>
        </Content>
      </Layout>
    )
  }
}
  
Channel=injectIntl(Channel);

export default Channel;
